/**
 * Store: Toast notifications
 * -----------------------------------------------------------------------------
 * Stores the toast notifications.
 */
import { defineStore } from 'pinia';

const useToastNotificationsStore = defineStore('toast-notifications', {
  state: () => ({
    toasts: [],
  }),

  actions: {
    addToast({
      title,
      id,
      ctaText,
      type,
      callback,
      productTitle,
      customClass = '',
      showCheckMark = true,
    }) {
      /* if adding toast gets spammed, we need to make sure the id is unique.
      You could also remove the math.random to have only one toast with the
      same title and id per second (to limit spamming) */
      const randomId = `${Date.now()}${Math.random() * 100}}`;
      const uniqueId = `${id}+${randomId}`;

      this.toasts.push({
        title,
        id: uniqueId,
        ctaText,
        type,
        callback,
        productTitle,
        customClass,
        showCheckMark,
      });
    },

    clearToast(id) {
      const index = this.toasts.findIndex((toast) => toast.id === id);
      this.toasts.splice(index, 1);
    },
  },
});

export default useToastNotificationsStore;
